import React from 'react';
// import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import './CompinedStyle.less';
let DateTimePicker = require('react-widgets/lib/DateTimePicker');

const renderDatePicker = ({ input, value, meta: { touched, error } }, ...rest) => ( //eslint-disable-line react/prop-types
   <div>
      <DateTimePicker
         {...input}
         format={"YYYY/MM/DD hh:mm:ss a"}
         defaultValue={new Date()}
         value={value}
         onBlur={() => input.onBlur(value)}
         {...rest}
      />;
      {touched && error && <span>{error}</span>}
   </div>
);

export default renderDatePicker;



/** WEBPACK FOOTER **
 ** ./src/components/FormTemplate/DateTimePickerControl.js
 **/